import { Injectable, signal } from '@angular/core';
import { SidebarState } from './sidebar/sidebar-state';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private _sidebarState = signal<SidebarState>('narrow');
  readonly sidebarState = this._sidebarState.asReadonly();

  setSidebarState(state: SidebarState): void {
    this._sidebarState.set(state);
  }

  toggleSidebarState(): void {
    const current: SidebarState = this._sidebarState();
    this._sidebarState.update(() => (current === 'narrow' ? 'regular' : 'narrow'));
  }
}
